import { FC, useContext, useEffect, useRef } from "react";

import { useNavigate } from "react-router-dom";

import { applyActionCode, getAuth, reload } from "firebase/auth";

import { PageLoader } from "@components/PageLoader/PageLoader";
import { AuthContext } from "@components/AuthProvider/contexts/Auth.context";

export const VerifyEmailRoute: FC = () => {
  const navigate = useNavigate();

  const authContext = useContext(AuthContext);

  const $toRefs = { navigate, authContext };
  const toRefs = useRef($toRefs);
  useEffect(() => {
    toRefs.current = $toRefs;
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const oobCode = searchParams.get("oobCode");
    if (!oobCode) return;
    applyActionCode(getAuth(), oobCode)
      .then(async () => {
        const {
          current: { authContext },
        } = toRefs;

        if (authContext) {
          await reload(authContext.authUser);
          toRefs.current.navigate("/portal?verified");
        } else {
          toRefs.current.navigate("/login?verified");
        }
      })
      .catch();
  }, []);

  return <PageLoader />;
};
